import authAxios from "../../utility/authAxios";
import { API_VERSION, SAAS_SERVICE_PATH } from "../../config/axios";
import { setHttpParams } from "../../utility/utils";

const API_URI = `${API_VERSION}/${SAAS_SERVICE_PATH}/counter-panel`;

export const getTripsByRoute = async (id) => {
    return authAxios.get(`${API_URI}/trip-routes/${id}/trips`);
};

export const getCountersByTrip = async (id) => {
    return authAxios.get(`${API_URI}/trips/${id}/counters`);
};

export const updateStatus = async (id, counter_id, data) => {
    return authAxios.patch(`${API_URI}/trip-counters/${id}?counter_id=${counter_id}`, data);
};
